import { HiMapPin } from "react-icons/hi2";

import { useContext } from "react";

import { Skeleton } from "@chakra-ui/react";

import {
  Icon,
  Text,
  Flex,
  Tag,
  Stack,
  Tooltip,
  useDisclosure,
  useMediaQuery
} from "../../internal/exports";

import { Image } from "@/storybook-components";
import { ContributionContext } from "../context";

const DEFAULT_PIN_CHAR = 32;

export const PinDetails = () => {
  const {
    pinType,
    pinAddress,
    isLoaded,
    pinColor,
    pinImageSrc,
    pinIcon,
    isAddressVisible,
    ariaLabelPinIcon
  } = useContext(ContributionContext);
  const { open, onOpen, onClose } = useDisclosure();
  const [isMobile] = useMediaQuery(["(max-width: 768px)"]);

  if (!(pinType || pinAddress)) return null;

  const pinStructure = () => {
    if (pinImageSrc) {
      return <Image src={pinImageSrc} h={6} w={6} alt={pinType} />;
    } else if (pinIcon) {
      return pinIcon || null;
    } else {
      return (
        <Icon
          justifySelf="flex-start"
          aria-label={ariaLabelPinIcon}
          minWidth={6}
          as={HiMapPin}
          width={6}
          height={6}
          color={pinColor || "purple.600"}
          data-testid="card-mapPinIcon"
        />
      );
    }
  };

  const pinTypeLength = pinType?.length;
  const tagProps = {
    colorPalette: "purple" as const,
    variant: "solid" as const,
    "data-testid": "card-pinTypeTag",
    bg: pinColor,
    px: 2,
    py: 1,
    mt: "6px",
    display: "inline-flex",
    alignItems: "center",
    style: { ...(pinIcon ? { height: 22, mt: 1 } : {}) }
  };

  const pinTagDetails = () => {
    return (
      <Tooltip
        open={open}
        label={pinType}
        hasArrow
        placement="top"
        openDelay={300}
        closeDelay={3000}
        closeOnClick={false}
      >
        <Tag
          {...tagProps}
          onClick={isMobile ? () => onOpen() : null}
          onTouchStart={isMobile ? () => onOpen() : null}
          onMouseEnter={!isMobile ? () => onOpen() : null}
          onMouseLeave={onClose}
        >
          <Text truncate maxW="100%">
            {pinType}
          </Text>
        </Tag>
      </Tooltip>
    );
  };

  const displayPintype = () => {
    return pinTypeLength > DEFAULT_PIN_CHAR ? (
      pinTagDetails()
    ) : (
      <Tag {...tagProps}>
        <Text truncate maxW="100%">
          {pinType}
        </Text>
      </Tag>
    );
  };

  if (!isLoaded) return <Skeleton h={10} my={2} w="full" />;

  return (
    <Stack width="full">
      <Flex gap={1}>
        {pinStructure()}
        {pinType && displayPintype()}
      </Flex>
      {isAddressVisible && (
        <Text fontSize="xs" fontWeight={500} data-test-id="card-pinAddressText">
          {pinAddress}
        </Text>
      )}
    </Stack>
  );
};
